import React, { Component } from 'react';
import autoBind from 'react-autobind';
import CircularProgress from 'material-ui/CircularProgress'; // Adjust import if using modern Material-UI
import { cleanHtml } from 'src/utils/helpers'; // Assuming this utility exists

class RichEditorMultiLanguage extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            richTextEditor: undefined,
            editorState: undefined,
            isRteLoading: true,
        };
    }

    componentDidMount() {
        require.ensure([], () => {
            const RichTextEditor = require('react-rte').default;
            this.setState({
                richTextEditor: RichTextEditor,
                editorState: this.props.isCreate
                    ? RichTextEditor.createEmptyValue()
                    : RichTextEditor.createValueFromString(this.props.value, 'html'),
                isRteLoading: false,
            });
        });
    }

    componentDidUpdate(prevProps) {
        if (!this.state.richTextEditor || !this.state.editorState) {
            return;
        }
        const currentValue = this.props.value ? this.props.value : '';
        const prevValue = prevProps.value ? prevProps.value : '';

        if (currentValue !== prevValue) {
            const currentHtmlInEditor = this.state.editorState.toString('html');

            if (currentHtmlInEditor !== currentValue) {
                const newEditorState = this.state.richTextEditor.createValueFromString(currentValue, 'html');
                this.setState({ editorState: newEditorState });
            }
        }
    }

    handleEditorChange(newEditorState) {
        this.setState({ editorState: newEditorState });
        this.props.onChange(cleanHtml(newEditorState.toString('html')));
    }

    render() {
        const { t, noLinks, placeholder, disabled: propDisabled, input } = this.props;
        const { richTextEditor: RichTextEditor, editorState, isRteLoading } = this.state;

        const meta = input && input.meta ? input.meta : {};
        const isDisabled = propDisabled || (input && input.disabled);

        if (isRteLoading || !RichTextEditor || !editorState) {
            return <CircularProgress />;
        }

        const toolbarConfig = {
            display: noLinks
                ? ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS']
                : [
                      'INLINE_STYLE_BUTTONS',
                      'BLOCK_TYPE_BUTTONS',
                      'LINK_BUTTONS',
                      'BLOCK_TYPE_DROPDOWN',
                      'HISTORY_BUTTONS',
                  ],
            INLINE_STYLE_BUTTONS: [
                { label: t('editor.bold'), style: 'BOLD', className: 'custom-css-class' },
                { label: t('editor.italic'), style: 'ITALIC' },
                { label: t('editor.underline'), style: 'UNDERLINE' },
            ],
            BLOCK_TYPE_DROPDOWN: [
                { label: t('editor.unstyled'), style: 'unstyled' },
                { label: t('editor.headline'), style: 'header-four' },
            ],
            BLOCK_TYPE_BUTTONS: [
                { label: t('editor.unordered_list'), style: 'unordered-list-item' },
                { label: t('editor.ordered_list'), style: 'ordered-list-item' },
            ],
        };

        return (
            <div>
                <RichTextEditor
                    toolbarConfig={toolbarConfig}
                    value={editorState}
                    placeholder={placeholder}
                    onChange={this.handleEditorChange}
                    disabled={isDisabled}
                />
                {meta.touched && meta.error && <div style={{ color: 'red', marginTop: '5px' }}>{meta.error}</div>}
            </div>
        );
    }
}

export default RichEditorMultiLanguage;
